// extracted by mini-css-extract-plugin
export default {"notificationIcon":"NotificationIcon_notificationIcon__ogYmn"};